'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyProductCTANav = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _StickyBar = require('acq-components/lib/base-components/StickyBar/StickyBar');

var _ProductCTANav = require('acq-components/lib/composite-components/ProductCTANav/ProductCTANav');

var _reactRedux = require('react-redux');

var _heroBanner = require('../../redux/selectors/heroBanner');

var selectors = _interopRequireWildcard(_heroBanner);

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

var _stickyApplyNow = require('../../redux/selectors/stickyApplyNow');

var _ApplyModal = require('../ApplyModal/ApplyModal');

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StickyProductCTANav = function StickyProductCTANav(_ref) {
  var styles = _ref.styles,
      dtmHelper = _ref.dtmHelper,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'dtmHelper']);

  if (!props.hasHeroBannerData) return null;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      showModal = _useState2[0],
      setModalState = _useState2[1];

  var openModal = function openModal() {
    return setModalState(true);
  };
  var closeModal = function closeModal() {
    return setModalState(false);
  };

  var stickyBannerArrayLinks = props.linksArray.map(function (link) {
    if (link && link.key === 'modal') {
      return (0, _assign2.default)({}, link, {
        href: undefined,
        to: undefined,
        url: undefined,
        onClick: function onClick() {
          (0, _dtmEvent.triggerDTMEvent)(dtmHelper.getDtmClickEventObj(_dtmConsts.DTM_CONSTS.actionApplyNow, _dtmConsts.DTM_CONSTS.stickyBanner));
          openModal();
        }
      });
    } else {
      return (0, _assign2.default)({}, link, {
        url: dtmHelper ? dtmHelper.getUrlByLinkObj(link, _dtmConsts.DTM_CONSTS.stickyBanner) : link.url,
        onClick: function onClick() {
          (0, _dtmEvent.triggerDTMEvent)({
            eventAction: link.dtm.eventAction,
            eventAsset: link.dtm.eventAsset + '-' + _dtmConsts.DTM_CONSTS.stickyBanner
          });
        }
      });
    }
  });

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _StickyBar.StickyBar,
      {
        isAlwaysVisible: false,
        scrollHeight: 300,
        hideAfterHeightFromBottom: 768,
        styles: styles.ProductCTANav
      },
      _react2.default.createElement(_ProductCTANav.ProductCTANav, {
        asset: props.stickyImage.url ? props.stickyImage : props.cardImage,
        productTitle: props.cardTitle,
        links: stickyBannerArrayLinks,
        styles: styles.ProductCTANav,
        qeId: 'StickyApply'
      })
    ),
    showModal && _react2.default.createElement(_ApplyModal2.default, {
      styles: styles,
      closeModal: closeModal,
      dtmHelper: dtmHelper
    })
  );
};

exports.StickyProductCTANav = StickyProductCTANav;
var mapStateToProps = function mapStateToProps(state) {
  return {
    hasHeroBannerData: selectors.getHasHeroBannerData(state),
    cardImage: selectors.getCardImage(state),
    stickyImage: selectors.getStickyImage(state),
    cardTitle: selectors.getCardTitle(state),
    linksArray: (0, _stickyApplyNow.getLinksArray)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StickyProductCTANav);